import ReactDOM from 'react-dom';
import React from 'react';
import FormularRezervari from './components/FormularRezervari';

const rootEl = document.getElementById('app-formular');

rootEl && ReactDOM.render(<FormularRezervari type={rootEl.dataset.type} />, rootEl);
